import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { Row } from '@/libraries/wpl/foundations/src/grid';
import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';

import { TryPageCard } from '../../components/try-page-card';
import { TryPageHeader } from '../../components/try-page-header';
import { messages } from '../messages';

/* Cards */
const JsmCard = () => {
	const intl = useIntl();

	const localizedLink = useLocalizedHref('/try/cloud/signup?bundle=jira-service-management');
	const localizedBodyText = intl.formatMessage({
		id: 'TryPageTemplate.supportAndFix.jsmCard.bodyText',
		defaultMessage:
			'Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast.',
	});

	const localizedCtaText = intl.formatMessage(messages.tryCloud);

	const jsmLogo = <LogoV3 brand={'jiraservicemanagement'} type="logo" appearance="brand" />;

	return (
		<TryPageCard
			logo={jsmLogo}
			link={localizedLink}
			bodyText={localizedBodyText}
			ctaText={localizedCtaText}
		/>
	);
};

const StatusCard = () => {
	const intl = useIntl();

	const localizedLink = useLocalizedHref('/try/cloud/signup?bundle=statuspage');
	const localizedBodyText = intl.formatMessage({
		id: 'TryPageTemplate.supportAndFix.statusCard.bodyText',
		defaultMessage:
			'Incidents happen. Keep your users informed with fewer support emails during downtime.',
	});

	const localizedCtaText = intl.formatMessage({
		id: 'TryPageTemplate.tryCloud',
		defaultMessage: 'Try cloud',
	});

	const statusPageLogo = <LogoV3 brand={'statuspage'} type="logo" appearance="brand" />;

	return (
		<TryPageCard
			logo={statusPageLogo}
			link={localizedLink}
			bodyText={localizedBodyText}
			ctaText={localizedCtaText}
		/>
	);
};

const sectionStyles = css({
	padding: '32px 0',
	position: 'relative',
	verticalAlign: 'baseline',
	marginInlineEnd: 'auto',
	marginInlineStart: 'auto',
	minWidth: '100%',
});

const SupportAndFixSection = () => {
	const intl = useIntl();
	const headerText = intl.formatMessage({
		id: 'TryPageTemplate.supportAndFix.headerText',
		defaultMessage: 'Support & fix',
	});

	return (
		<UFOSegment name={'support-and-fix'}>
			<div css={sectionStyles}>
				<Row>
					<TryPageHeader dividerColor="#ff8b00" headerText={headerText} />
				</Row>
				<Row layout="6-6">
					<JsmCard />
					<StatusCard />
				</Row>
			</div>
		</UFOSegment>
	);
};

export default SupportAndFixSection;
